import Proj4 from 'proj4';
import wkt from 'wkt';

function convertGeojsonCRS(geojson, currentCRS = 'EPSG:3857', targetCRS = 'EPSG:4326') {
  const geoJsonCoords = geojson.coordinates[0][0].map((coordinate) =>
    Proj4(currentCRS, targetCRS, coordinate),
  );

  const { crs, ...geojsonWithoutCRS } = geojson;
  return {
    ...geojsonWithoutCRS,
    coordinates: [[geoJsonCoords]],
  };
}

function createGeojsonFromAreaMonitoringGeometry(areaMonitoringGeometry) {
  return wkt.parse(areaMonitoringGeometry);
}

export { convertGeojsonCRS, createGeojsonFromAreaMonitoringGeometry };
